// @flow

import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import { closeChat } from '../../../react/features/chat/actions.any';
import { resetNbUnreadPollsMessages } from '../../../react/features/polls/actions';
import debounce from 'lodash/debounce';
import WildixUIEvents from '../../service/WildixUIEvents';

/**
 * Listens for changes in the chat when private message received.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/chat'].privateMessageRecipient,
    /* listener */ (privateRecipient, store, prevPrivateRecipient) => {
        if (privateRecipient !== prevPrivateRecipient) {
            APP.wildix.eventEmitter.emit(WildixUIEvents.PRIVATE_MESSAGE, privateRecipient);
        }
    });

let clearMessagesOnce = false;


/**
 * Listens for changes in the chat state to calculate the dimensions of the tile view grid and the tiles.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/chat'].messages,
    /* listener */ debounce((messages, { dispatch }) => {
        if (APP.isExternalProvider) {
            return;
        }

        if (messages?.length > 0 && !clearMessagesOnce) {
            const elCounterChat = document.querySelector('.badge-round');

            dispatch(closeChat());
            dispatch(resetNbUnreadPollsMessages());
            elCounterChat.style.opacity = '1';
            clearMessagesOnce = true;
        }
    }, 100));
